import axios from "axios"

axios.interceptors.response.use(null, error => {
	const expectedError = error.response && error.response.status >= 400 && error.response.status < 500

	if (!expectedError) {
		if (error.Error === "Network Error") {
			console.error("Network Error")
		}
	}

	return Promise.reject(error)
})

export function setJwt(jwt) {
	if (typeof window === "object") {
		axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`
	}
}

let http = {
	get: axios.get,
	post: axios.post,
	patch:axios.patch,
	put: axios.put,
	delete: axios.delete,
	setJwt
}
export default http
